import React from "react";
import { HourglassLine, QuestionMark, CheckLine, CloseLine } from "@ui/IconV2/react";
import t from "../../i18n";
import { colors } from "@ui/Theme";

export const getFaultStatusText = (status: string): string => {
  switch (status) {
    case "TO_BE_ANALYSED":
    case "BACK_TO_BE_ANALYSED":
      return t("fault.chart.evolution.tooltip.status.to_be_analysed");
    case "SUSPECTED":
      return t("fault.chart.evolution.tooltip.status.suspected");
    case "CONFIRMED":
      return t("fault.chart.evolution.tooltip.status.confirmed");
    case "REJECTED":
    case "LEGACY_REJECTED":
      return t("fault.chart.evolution.tooltip.status.rejected");
    default:
      return "";
  }
};

export const getEnhancedFaultStatusText = (faultValueStatus: string): string => {
  switch (faultValueStatus) {
    case "SUSPECTED":
      return getFaultStatusText("SUSPECTED");
    case "TO_BE_ANALYSED":
    case "BACK_TO_BE_ANALYSED":
      return getFaultStatusText("TO_BE_ANALYSED");
    case "CONFIRMED":
      return getFaultStatusText("CONFIRMED");
    case "REJECTED":
      return getFaultStatusText("REJECTED") + " " + t("common.fault_status.rejected.relaunch");
    case "LEGACY_REJECTED":
      return (
        getFaultStatusText("LEGACY_REJECTED") +
        " " +
        t("common.fault_status.legacy_rejected.relaunch")
      );
    default:
      return "";
  }
};

export const getFaultStatusTextIcon = (status: string): React.ReactNode => {
  switch (status) {
    case "TO_BE_ANALYSED":
    case "BACK_TO_BE_ANALYSED":
      return <HourglassLine size="s" color={colors.carbon800} />;
    case "SUSPECTED":
      return <QuestionMark size="s" color={colors.carbon800} />;
    case "CONFIRMED":
      return <CheckLine size="s" color={colors.carbon800} />;
    case "REJECTED":
      return <CloseLine size="s" color={colors.carbon800} />;
    case "LEGACY_REJECTED":
      return <CloseLine size="s" color={colors.carbon800} />;
    default:
      return null;
  }
};
